module.exports = __webpack_public_path__ + "img/placeholder-solid-color.5287762e.svg";